function Templating() {
    return (
        <div>
            <a
                href="https://wa.me/6287776572240?text=Hallo,%20Saya%20ingin%20bertanya%20tentang%20webinar.%20Terima%20kasih."
                target="_blank"
                rel="noopener noreferrer"
                style={{
                position: "fixed",
                bottom: "20px",
                right: "20px",
                backgroundColor: "#25D366",
                color: "white",
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "28px",
                boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
                zIndex: 9999,
                textDecoration: "none"
                }}
            >
                <i className="bi bi-whatsapp"></i>
            </a>
            
            <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.css" rel="stylesheet">
            </link>
        </div>
    );
}

export default Templating;